// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"c570b96a","389":"a31860fd","440":"c6c0ddda","530":"939cc0be"}[chunkId] + ".chunk.js";
};